import React from 'react'
import SimpleCard from 'components/SimpleCard'
import TabContent from 'components/TabConfiguracao/TabContent'
import { TabItem } from 'components/TabConfiguracao/TabsMenu'
import Main from 'layouts/main'
import Etapas from './components/Etapas'
import SLAs from './components/SLAs'
import Pipelines from './components/Pipelines'
import * as configuracaoKanbanActions from 'store/modules/backoffice/configuracaoKanban/actions'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { CONFIGURACAO_KANBAN } from 'store/modules/backoffice/configuracaoKanban/types'
import useRedux from 'hooks/useRedux'

const ConfiguracaoKanban = () => {
  const { activeTab } = useSelector<ApplicationState, CONFIGURACAO_KANBAN>(
    (state) => state.configuracaoKanban
  )

  const { dispatch } = useRedux()

  const tabs: TabItem[] = [
    {
      label: 'Pipelines',
      icon: <></>,
      content: <Pipelines />
    },
    {
      label: 'Etapas',
      icon: <></>,
      content: <Etapas />
    },
    {
      label: 'SLAs',
      icon: <></>,
      content: <SLAs />
    }
  ]

  return (
    <Main>
      <SimpleCard>
        <TabContent
          value={activeTab}
          onChange={(_, newValue) => {
            dispatch(configuracaoKanbanActions.setActiveTab(newValue))
          }}
          tabs={tabs}
        />
      </SimpleCard>
    </Main>
  )
}

export default ConfiguracaoKanban
